<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <div style="padding: 0 10px;width: 100%;">
        <v-btn
          color="green"
          dark
          v-bind="attrs"
          v-on="on"
          block
        >
          Abrir ticket
        </v-btn>
        </div>
      </template>
      <v-card v-if="editedItem">
        <v-toolbar
          dark
          color="primary"
          elevation="0"
        >
          <v-btn
            icon
            dark
            @click="handleClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Abrir tiket</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="handleSave"
            >
              Crear ticket
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list
          three-line
          subheader
        >
          <v-list-item>
            <v-list-item-content>
              <v-select
                v-model="editedItem.TicketType"
                :items="[{
                    id: 'incidencia',
                    name: 'incidencia',
                  },
                  {
                    id: 'solicitud',
                    name: 'solicitud',
                  },
                ]"
                itemText="name"
                itemValue="id"
                outlined
                hide-details
                label="Tipo de ticket"
              />
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field
                label="Email o teléfono de contacto"
                outlined
                v-model="editedItem.Contact"
                hideDetails
              />
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field
                :rules="rules"
                maxlength="100"
                label="Asunto corto"
                outlined
                v-model="editedItem.Name"
              />
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-textarea
                outlined
                name="input-7-4"
                label="Descripción"
                hideDetails
                v-model="editedItem.Description"
              />
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <small style="color: #CCCCC;margin-bottom: 20px;">Aportar imagen aclaratoria de ser necesario:</small>
        <select-image
          v-model="editedItem.newImage"
          :isFullWidth="true"
          :enterpriseID="workspaceID"
          :imageOld='image'
          style="margin-left:0px;margin-top:15px;margin-right: 0px;"
          width="100px"
          :onBase64Change="handleChangeImage"
        />
              <!--select-image 
                :image="image"
                :onChange="handleChangeImage"
                :locale="locale"
                :imageWidth="800"
                :imageHeight="600"
                :aspectRatio="16/9"
                folder="tickets"
                :limit="1024"
              /-->
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import utilsService from '@/services/utils.js'
import api from '@/services/api'
import SelectImage from '@/components/SelectImage'
export default {
  components: {
    SelectImage,
  },
  props: {
    onClose: {
      type: Function,
      required: true,
    },
    locale: {
      type: String,
      default: 'es',
    },
  },
  data: () => ({
    dialog: false,
    editedItem: null,
    image: null,
  }),
  computed: {
    rules () {
      return [v => v.length <= 100 || 'Max 50 characters']
    },
    environment () {
      return this.$route.meta.environment
    },
    userID () {
      return utilsService.getUserID()
    },
    workspaceID () {
      return utilsService.getEnterpiseID()
    },
  },
  watch: {
    dialog () {
      this.editedItem = {
        TicketType: 'solicitud',
        Name: '',
        Description: '',
      }
    },
  },
  methods: {
    handleClose () {
      this.onClose()
      this.dialog = false
    },
    handleChangeImage (v) {
      if (!v) return
      this.image = v.base64
      this.editedItem.newImage = v
    },
    async handleSave () {
      const { dviewcontentWorkspace, dtouchWorkspace, bookingWorkspace, turismoWorkspace, playersWorkspace, dfilesWorkspace } = this.$store.state.app
      this.editedItem.UserID = this.userID
      this.editedItem.WorkspaceID = this.workspaceID
      this.editedItem.WorkspaceName = !this.editedItem.WorkspaceID ? null : await new Promise((resolve) => api.getItem (`enterprises`, false, this.editedItem.WorkspaceID)
        .then(response => {
          resolve(response ? response.Name : null)
        })
        .catch(error => {
          console.log(error)
          resolve(null)
        }))
      console.log(this.editedItem)
      
      const result = await new Promise((resolve) => api.addItem(`tickets`, this.editedItem)
        .then(response => {
          resolve(response ? true : false)
        })
        .catch(error => {
          console.log(error)
          alert('error')
          resolve(null)
        }))
      if (result) {
        alert('Ticket creado con exito.')
        this.handleClose()
      } else {
        alert('error')
      }
    },
  },
}
</script>


